import React from 'react';
import { Link } from 'react-router-dom';
import { FileText, RefreshCw, ShieldCheck } from 'lucide-react';
export function WarrantyPage() {
  return <div className="bg-white py-16" data-id="element-606">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-607">
        <div className="text-center mb-16" data-id="element-608">
          <h1 className="text-4xl font-bold text-brand-dark mb-4" data-id="element-609">
            Warranty & Returns
          </h1>
          <p className="text-xl text-gray-600" data-id="element-610">
            Simple, transparent policies for professionals.
          </p>
        </div>

        <div className="space-y-12" data-id="element-611">
          {/* Warranty Section */}
          <section className="bg-brand-light p-8 rounded-xl border border-gray-200" data-id="element-612">
            <div className="flex items-start mb-6" data-id="element-613">
              <ShieldCheck className="h-8 w-8 text-brand-yellow mr-4 mt-1" data-id="element-614" />
              <div data-id="element-615">
                <h2 className="text-2xl font-bold text-brand-dark mb-4" data-id="element-616">
                  Limited Warranty
                </h2>
                <div className="prose text-gray-600" data-id="element-617">
                  <p className="mb-4" data-id="element-618">
                    Precision Pro Sprayers warrants its ForceX products to be
                    free from defects in material and workmanship for a period
                    of one (1) year from the date of original purchase.
                  </p>
                  <p className="mb-4" data-id="element-619">
                    This warranty covers the pump, motor, and housing. Wear
                    items such as hoses, seals, and nozzles are covered for 90
                    days against manufacturing defects.
                  </p>
                  <p data-id="element-620">
                    <strong data-id="element-621">Exclusions:</strong> Damage caused by misuse, abuse,
                    neglect, alterations, or use with incompatible chemicals is
                    not covered.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Returns Section */}
          <section className="bg-brand-light p-8 rounded-xl border border-gray-200" data-id="element-622">
            <div className="flex items-start mb-6" data-id="element-623">
              <RefreshCw className="h-8 w-8 text-brand-yellow mr-4 mt-1" data-id="element-624" />
              <div data-id="element-625">
                <h2 className="text-2xl font-bold text-brand-dark mb-4" data-id="element-626">
                  Return Policy
                </h2>
                <div className="prose text-gray-600" data-id="element-627">
                  <p className="mb-4" data-id="element-628">
                    If you are not satisfied with your purchase, you may return
                    unused items in their original packaging within 30 days of
                    delivery for a refund.
                  </p>
                  <p className="mb-4" data-id="element-629">
                    A 15% restocking fee applies to all returns. Shipping costs
                    are non-refundable, and the customer is responsible for
                    return shipping charges.
                  </p>
                  <p data-id="element-630">
                    Please contact our support team to obtain a Return
                    Merchandise Authorization (RMA) number before shipping any
                    items back.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Process Section */}
          <section className="bg-white p-8 rounded-xl border-2 border-brand-yellow/20" data-id="element-631">
            <div className="flex items-start mb-6" data-id="element-632">
              <FileText className="h-8 w-8 text-brand-yellow mr-4 mt-1" data-id="element-633" />
              <div data-id="element-634">
                <h2 className="text-2xl font-bold text-brand-dark mb-4" data-id="element-635">
                  How to File a Claim
                </h2>
                <div className="prose text-gray-600" data-id="element-636">
                  <ol className="list-decimal pl-5 space-y-2" data-id="element-637">
                    <li data-id="element-638">Locate your proof of purchase (invoice or receipt).</li>
                    <li data-id="element-639">Take photos of the issue if applicable.</li>
                    <li data-id="element-640">
                      Contact our support team via the contact form or phone.
                    </li>
                    <li data-id="element-641">
                      We will troubleshoot the issue and provide an RMA or
                      replacement part if covered.
                    </li>
                  </ol>
                </div>
                <div className="mt-8" data-id="element-642">
                  <Link to="/contact" className="text-brand-yellow font-bold hover:underline" data-id="element-643">
                    Contact Support Team →
                  </Link>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>;
}